exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bulk-unsub-1{fill:none}\n.bulk-unsub-2{fill:#ee7470;opacity:.331}\n.bulk-unsub-3{fill:#1e4e69}\n.bulk-unsub-4{fill:#fad1d0}\n.bulk-unsub-5{fill:#fff}\n\n", ""]);
